module.exports = __webpack_public_path__ + "static/20230619_065-d8000d238e94e149d2c4a22502aeb634.jpg";